import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

/**
 * Opens the page a clicked push notification points at (t1217) when the portal
 * is already open. Renders no DOM. Only same-origin relative paths are followed;
 * support-ticket clicks are handled by `TicketAlerts`.
 */
export function SwNavigation() {
  const navigate = useNavigate()

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return
    const onMessage = (event: MessageEvent) => {
      const message = event.data as { type?: string; url?: unknown } | null
      if (message?.type !== 'open-url') return
      const url = message.url
      if (typeof url !== 'string' || !url.startsWith('/') || url.startsWith('//')) return
      void navigate({ href: url })
    }
    navigator.serviceWorker.addEventListener('message', onMessage)
    return () => navigator.serviceWorker.removeEventListener('message', onMessage)
  }, [navigate])

  return null
}
